enum WorkerPositionStatus {
    Pending = 10,
    Verified = 90

}

export default WorkerPositionStatus;